import { Injectable } from '@angular/core';

const GLOBAL_PREFIX = 'Liquitics-'

@Injectable()
export class LocalDBService {

    private registeredPromises: Map<string, Promise<any>> = new Map();

    getItem(key: string): string {
        return window.localStorage.getItem(GLOBAL_PREFIX + key);
    }

    setItem(key: string, value: string): void {
        window.localStorage.setItem(GLOBAL_PREFIX + key, value);
    }

    removeItem(key: string): void {
        window.localStorage.removeItem(GLOBAL_PREFIX + key);
    }

    registerPromise(key: string, promise: Promise<any>) {
        this.registeredPromises.set(key, promise);
    }

    unregisterPromise<T>(key: string) {
        this.registeredPromises.delete(key);
    }

    getRegisteredPromise<T>(key: string): Promise<T> {
        return this.registeredPromises.get(key);
    }

}
